import { Button } from "@mui/material";
import { useTranslation } from "react-i18next";

import { AddButtonIcon } from "../../../../assets/icons/entity-icons";

const AddLocation = ({ singular, onAdd }: { singular: boolean; onAdd: () => void }) => {
  const { t } = useTranslation("profiles", { keyPrefix: "entityProfileEdit" });
  return (
    <Button
      variant="outlined-sm"
      fullWidth
      onClick={onAdd}
      sx={{
        borderRadius: "8px",
        border: "1px solid var(--Gray-300, #D0D5DD) !important",
        boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
        background: "transparent !important",
        justifyContent: "flex-start",
        gap: "10px",
        color: "var(--Gray-700, #344054) !important",
        fontFamily: "Montserrat",
        fontSize: "18px",
        fontStyle: "normal",
        fontWeight: 600,
        lineHeight: "28px",
      }}
      startIcon={<AddButtonIcon />}
    >
      {singular ? t("addCountry") : t("addAnotherCountry")}
    </Button>
  );
};

export default AddLocation;
